export default __webpack_public_path__ + "static/media/section3-icon2.36ace9f1.png";